import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const TermsArray = ({ terms, setTerms }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newTermsArray = terms.map((term) => {
      if (term.id !== id) return term;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...term,
          [inputName]: {
            ...term?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...term, [name]: value };
    });

    setTerms(newTermsArray);
  };

  const removeTerm = (termId) => {
    const newTerms = terms.filter((term, index) => term.id !== termId);
    setTerms(() => newTerms);
  };

  const addTerm = () => {
    setTerms(() => [...terms, { id: v4(), description: {} }]);
  };

  return (
    <div className="form-group branches features_ ">
      <Row>
        <Col lg={12}>
          <h5>
            <FormattedMessage id={"all-terms"} />
          </h5>

          {terms.map((term, index) => {
            return (
              <div key={term.id} className="add-multi-component">
                <button
                  type="button"
                  onClick={() => removeTerm(term.id)}
                  className="removeImg"
                >
                  <img src={removeImg} alt="" />
                </button>
                <Row>
                  <Col lg={6} xs={12}>
                    <h5>
                      {" "}
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"arabic-language"} /> )
                    </h5>
                    <textarea
                      type="text"
                      name="description.ar"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, term.id)}
                      value={term?.description?.ar}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <h5>
                      {" "}
                      <FormattedMessage id={"description"} /> ({" "}
                      <FormattedMessage id={"english-language"} /> )
                    </h5>
                    <textarea
                      type="text"
                      name="description.en"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, term.id)}
                      value={term?.description?.en}
                      dir="ltr"
                    />
                  </Col>
                </Row>
              </div>
            );
          })}
        </Col>

        <Col lg={4} xs={12} className="text-left">
          <button
            type="button"
            className="btn btn-green add_new_section__"
            onClick={() => {
              addTerm();
            }}
          >
            <FormattedMessage id={"addTerm"} />
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default TermsArray;
